import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const EllipsisVerticalIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/ellipsis-vertical"><g id="Icon"><path d="M12 3.6001C12.9941 3.6001 13.8 4.40598 13.8 5.4001C13.8 6.39421 12.9941 7.2001 12 7.2001C11.0058 7.2001 10.2 6.39421 10.2 5.4001C10.2 4.40598 11.0058 3.6001 12 3.6001Z" fill="currentColor" /><path d="M12 10.2001C12.9941 10.2001 13.8 11.006 13.8 12.0001C13.8 12.9942 12.9941 13.8001 12 13.8001C11.0058 13.8001 10.2 12.9942 10.2 12.0001C10.2 11.006 11.0058 10.2001 12 10.2001Z" fill="currentColor" /><path d="M13.8 18.6001C13.8 17.606 12.9941 16.8001 12 16.8001C11.0058 16.8001 10.2 17.606 10.2 18.6001C10.2 19.5942 11.0058 20.4001 12 20.4001C12.9941 20.4001 13.8 19.5942 13.8 18.6001Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default EllipsisVerticalIcon;